<template>
  <div class="card-container-outer">
    <div class="card-container-inner">
      <div v-if="posts.length > 1">
        <hr class="my-4">

        <h4 class="mb-3">
          All posts
        </h4>
        <div
          v-for="({title}, index) in posts"
          :key="`${index}-${title}`"
          class="text-container mb-1"
          @click="clickPost(index)"
          @keypress="clickPost(index)"
        >
          <ProductsFoundersCardItemBody
            :value="title"
            :highlighted="highlightSelectedPost && postIndex === index"
          />
        </div>
      </div>
      <div v-if="hasLinks">
        <hr class="my-4">

        <h4 class="mb-3">
          Helpful links
        </h4>
        <div
          v-for="(link, index) in links"
          :key="`${index}-${link.title}`"
          class="text-container mb-1"
        >
          <a :href="link.url" target="_blank">
            <ProductsFoundersCardItemBody :value="link.title" />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductsFoundersCardItemBody from './ProductsFoundersCardItemBody';

export default {
  components: {
    ProductsFoundersCardItemBody,
  },
  props: {
    posts: {
      type: Array,
      required: true,
    },
    links: {
      type: Array,
      default: () => ([]),
    },
    postIndex: {
      type: Number,
      default: 0,
    },
    highlightSelectedPost: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasLinks() {
      return !!this.links?.length;
    },
  },
  methods: {
    clickPost(index) {
      this.$emit('click-post', index);
    },
  },
};
</script>

<style scoped lang="scss">
  @import '~/styles/dorado/main'; // TODO -- Remove once auto imported

  .card-container-outer {
    width: 100%;

    .text-container {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      color: $deep-ocean;
    }

    a:hover {
      text-decoration: none;
    }
  }

</style>
